module.exports = 'ttb.dashboard.remainingDays';

angular.module(module.exports, [
    require("./remaining-days.component")
]);


// WEBPACK FOOTER //
// ./components/remaining-days/index.js